import "./SingleTourTemplate.module.css"
import MainNavigation from "@/reusable_sections/Header"
import SingleTourTemplateSection from "./sections/SingleTourTemplateSection"
import BrandFooter from "@/reusable_sections/Footer"

export default function SingleTourTemplatePage() {

  return (
    <div>
      <MainNavigation />
      <SingleTourTemplateSection />
      <BrandFooter />
    </div>
  )
}
